// Canvas color tokens for the chart renderers. Two palettes (light / dark);
// `Theme` is a mutable object the renderers read every frame, so calling
// setChartTheme() live-updates the chart on a theme switch.
type Palette = {
  bg: string;
  paneBg: string;
  grid: string;
  gridStrong: string;
  axisBg: string;
  axisBorder: string;
  text: string;
  textDim: string;
  textBright: string;
  crosshair: string;
  crosshairLabelBg: string;
  crosshairLabelText: string;
  bull: string;
  bear: string;
  bullWick: string;
  bearWick: string;
  volumeBull: string;
  volumeBear: string;
  lastPriceBull: string;
  lastPriceBear: string;
  accent: string;
  selection: string;
  handleFill: string;
  handleStroke: string;
  drawing: string;
  drawingText: string;
};

// Light (Kiwi white-green)
const light: Palette = {
  bg: "#ffffff",
  paneBg: "#ffffff",
  grid: "#eef2ec",
  gridStrong: "#e0e6dc",
  axisBg: "#ffffff",
  axisBorder: "#e0e6dc",
  text: "#5b6a60",
  textDim: "#8a938c",
  textBright: "#14201a",
  crosshair: "#9aa39b",
  crosshairLabelBg: "#26302a",
  crosshairLabelText: "#f4f7f1",
  bull: "#0e9e86",
  bear: "#e5484d",
  bullWick: "#0e9e86",
  bearWick: "#e5484d",
  volumeBull: "rgba(14,158,134,0.42)",
  volumeBear: "rgba(229,72,77,0.42)",
  lastPriceBull: "#0e9e86",
  lastPriceBear: "#e5484d",
  accent: "#5aa30a",
  selection: "#5aa30a",
  handleFill: "#ffffff",
  handleStroke: "#5aa30a",
  drawing: "#5aa30a",
  drawingText: "#14201a",
};

// Dark (soft slate + indigo/violet)
const dark: Palette = {
  bg: "#131824",
  paneBg: "#131824",
  grid: "#1e2431",
  gridStrong: "#29303f",
  axisBg: "#131824",
  axisBorder: "#2a3140",
  text: "#8a91a4",
  textDim: "#5d6474",
  textBright: "#e6e9f2",
  crosshair: "#727a8c",
  crosshairLabelBg: "#2a3140",
  crosshairLabelText: "#e6e9f2",
  bull: "#2bb29a",
  bear: "#f0616d",
  bullWick: "#2bb29a",
  bearWick: "#f0616d",
  volumeBull: "rgba(43,178,154,0.42)",
  volumeBear: "rgba(240,97,109,0.42)",
  lastPriceBull: "#2bb29a",
  lastPriceBear: "#f0616d",
  accent: "#8b8cf5",
  selection: "#8b8cf5",
  handleFill: "#131824",
  handleStroke: "#8b8cf5",
  drawing: "#8b8cf5",
  drawingText: "#e6e9f2",
};

// Mutable live palette (renderers import this and read it per-frame).
export const Theme: Palette = { ...light };

export function setChartTheme(mode: "light" | "dark") {
  Object.assign(Theme, mode === "dark" ? dark : light);
}

export const Fonts = {
  axis: "11px -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  legend: "12px -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  mono: "11px ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
} as const;
